export default __webpack_public_path__ + "static/media/Category_HomeImprovement_135x195.e6dcd607.jpg";